var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "field-wrapper",
        "dropdown",
        _vm.name,
        {
          open: _vm.open,
          disabled: _vm.disabled
        }
      ]
    },
    [
      _c("fieldset", { ref: "dropdownWrapper" }, [
        _c(
          "button",
          {
            ref: "dropdownToggle",
            class: [
              "dropdown-toggle",
              "dc-button",
              "dc-button--has-title",
              "dc-button--has-icon",
              {
                open: _vm.open
              }
            ],
            attrs: {
              "aria-controls": _vm.dropdownId,
              "aria-expanded": _vm.open,
              "aria-disabled": _vm.disabled
            },
            on: {
              click: function($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.toggle.apply(null, arguments)
              }
            }
          },
          [
            _c("legend", { attrs: { for: _vm.name } }, [
              _vm._v(_vm._s(_vm.currentLegendText))
            ]),
            _vm._v(" "),
            _vm._m(0)
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "dropdownOptions",
            class: [
              "dropdown-wrapper",
              {
                open: _vm.open
              }
            ],
            attrs: { id: _vm.dropdownId, "aria-hidden": !_vm.open }
          },
          [
            !_vm.hasHierarchy
              ? _c("OptionsList", {
                  attrs: {
                    showAllOption: _vm.showAllOption,
                    checkedValues: _vm.checkedValues,
                    options: _vm.options,
                    fieldName: _vm.name
                  },
                  on: { "update-filter": _vm.choose, "reset-filter": _vm.reset }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.hasHierarchy
              ? _c("OptionsAccordion", {
                  attrs: {
                    showAllOption: _vm.showAllOption,
                    checkedValues: _vm.checkedValues,
                    options: _vm.options,
                    fieldName: _vm.name
                  },
                  on: { "update-filter": _vm.choose, "reset-filter": _vm.reset }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "menu-dots" }, [
      _c("span", { staticClass: "dot top" }),
      _vm._v(" "),
      _c("span", { staticClass: "dot middle" }),
      _vm._v(" "),
      _c("span", { staticClass: "dot bottom" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }